import { useContext } from 'react';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { MegaMenuContext } from '@designsystem/stories/04-organisms/MegaMenuContext';
import { SidepanelContext } from '@designsystem/stories/04-organisms/SidepanelContext';

export const DesignSystemBodyClass = () => {
  const [mega_menu_open, ,] = useContext<any>(MegaMenuContext);
  const [sidepanel_open, ,] = useContext<any>(SidepanelContext);
  return (
    <>
      {mega_menu_open && <BodyClass className="mega-menu-open" />}
      {sidepanel_open && <BodyClass className="sidepanel-open" />}
    </>
  );
};
